// @ts-nocheck
import { useState, useEffect } from 'react';
import { TextField } from '@mui/material';
import ReactQuill from 'react-quill';
import DOMPurify from 'dompurify';
import FieldWithDecimalControlled from 'components/__v2__/FieldWithDecimalControlled';
import { useStyles } from '../../../style';
import { formats, modules } from '../../../../../config/constant';

const TextPreview = ({
  field,
  tableId,
  tableType,
  rowIndex,
  colIndex,
  updateAnswer,
  updateAnswerInPrefilledElements,
  shouldBeReadOnly,
}) => {
  const classes = useStyles();
  const [value, setValue] = useState(field?.answer);

  const handleBlur = () => {
    updateAnswer(tableId, rowIndex, colIndex, value);
    if (updateAnswerInPrefilledElements) {
      updateAnswerInPrefilledElements(tableId, value, tableType, '', {
        rowIndex,
        colIndex,
        tableElementType: field?.type,
      });
    }
  };

  const handleQuillChange = (value) => {
    const cleanedValue = DOMPurify.sanitize(value);
    setValue(cleanedValue);
  };

  useEffect(() => {
    setValue(field?.answer);
  }, [field?.answer]);

  if (field.name === 'Long Text') {
    return (
      <ReactQuill
        value={value}
        modules={modules}
        formats={formats}
        className={classes.editorStyles}
        onChange={handleQuillChange}
        onBlur={handleBlur}
        onKeyUp={handleBlur}
        readOnly={shouldBeReadOnly}
      />
    );
  }

  if (field.type === 'number') {
    return (
      <FieldWithDecimalControlled
        id={field.id}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onBlur={handleBlur}
        variant="outlined"
        placeholder="Your Answer"
        readOnly={shouldBeReadOnly}
      />
    );
  }

  return (
    <TextField
      type={field.type}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={handleBlur}
      variant="outlined"
      fullWidth
      placeholder="Your Answer"
      disabled={shouldBeReadOnly}
    />
  );
};

export default TextPreview;
